export default __webpack_public_path__ + "static/media/regular-lavenda.288ddedf.jpg";